import React from 'react';
import PropTypes from 'prop-types';

import IconArrowDownSimple from 'components/icons/iconArrowDownSimple';

const MenuButtonLabel = ({ title }) => (
  <>
    <span>{title}</span>
    <span>
      <IconArrowDownSimple />
    </span>
  </>
);

MenuButtonLabel.propTypes = {
  title: PropTypes.string,
};

export default MenuButtonLabel;
